import { CreateAddressDto, PostalAddress } from '~/adapters/services/accounts/postalAddresses/types';
import { AddressFormState } from './types';

/**
 * transforms PostalAddress from GET API to type used in react form state
 * that means deleting unwanted fields and converting nullable fields to empty strings when null
 * @param address PostalAddress
 */
export const addressToFormState = (address: PostalAddress): AddressFormState => {
    const { id, accountId, updatedAt, createdAt, ...addressDto } = address;

    return {
        ...addressDto,
        addressRegion: addressDto.addressRegion ?? '',
        addressDescription: addressDto.addressDescription ?? '',
        email: addressDto.email ?? '',
        telephone: addressDto.telephone ?? '',
    };
};

/**
 * transforms react form state into POST/PUT API Dto
 * that means converting empty strings back to null when ''
 * also convert nullable addressCountry to '' when null, but that should be caught by form validation
 * @param addressState AddressFormState
 */
export const formStateToDto = (addressState: AddressFormState): CreateAddressDto => ({
    ...addressState,
    addressCountry: addressState.addressCountry ?? '',
    addressRegion: addressState.addressRegion || null,
    addressDescription: addressState.addressDescription || null,
    email: addressState.email || null,
    telephone: addressState.telephone || null,
});
